import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SplitText } from "@/components/SplitText";

/**
 * Home-page teaser for the art practice.
 *
 * The full treatment — the craft movements and the finished pieces — lives on
 * `/art`, which the nav now routes to. This section keeps the manifesto and
 * hands off to that page, so the two never drift apart.
 */
export function ArtSection() {
  return (
    <section
      id="art"
      className="relative scroll-mt-24 overflow-hidden border-y border-border/60 bg-espresso text-ivory"
    >
      {/* faint diagonal hatch, like a canvas weave */}
      <div
        aria-hidden="true"
        className="hatch pointer-events-none absolute inset-0 opacity-[0.05]"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-24 left-1/2 h-96 w-[36rem] -translate-x-1/2 rounded-full bg-gold/12 blur-[110px]"
      />

      <div className="relative mx-auto max-w-6xl px-6 py-24 sm:py-32 lg:px-10">
        <div className="max-w-3xl">
          <Reveal variant="fade">
            <p className="font-sans text-[0.6875rem] font-medium tracking-[0.32em] text-gold uppercase">
              The Art
            </p>
          </Reveal>

          <SplitText
            as="h2"
            text="Makeup is not decoration. It is a medium."
            className="mt-6 font-display text-[clamp(2.25rem,6vw,4.25rem)] leading-[1.05] font-light"
          />

          <Reveal variant="up" delay={220}>
            <p className="mt-8 max-w-xl font-sans text-sm leading-relaxed font-light text-ivory/70 sm:text-base">
              A face is a surface, and everything I do on it is a decision about light. The
              craft lives in the parts nobody sees: the priming, the thin layers, the one
              stroke that had to be correct the first time. What remains visible is only the
              finished painting.
            </p>
          </Reveal>

          <Reveal variant="up" delay={320}>
            <a
              href="/art"
              className="group mt-10 inline-flex items-center gap-3 rounded-full border border-ivory/25 px-8 py-4 font-sans text-[0.6875rem] tracking-[0.22em] uppercase transition-colors duration-500 hover:border-gold hover:bg-gold hover:text-espresso"
            >
              View the portfolio
              <ArrowUpRight
                className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                strokeWidth={1.5}
              />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
